export interface IFileDocument {
    name: string;
    link: string;
    mime: string;
    size: number;
}

export enum FileType {
    pdf = 'application/pdf'
}

export class FileDocument implements IFileDocument {
    link: string;
    mime: string;
    name: string;
    size: number;

    constructor(file: File, link: string) {
        this.name = file.name;
        this.mime = file.type;
        this.size = file.size;
        this.link = link;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/file-document.ts